import { Reducer } from 'redux';
import { types } from './WorkspaceActions';
import {
    IWorkspaceState,
    IWorkspaceAction,
} from '../../common/model/WorkspaceModels';

export const workspaceReducer: Reducer<IWorkspaceState, IWorkspaceAction> = (
    state: IWorkspaceState = {
        workspaceList: { pageSize: 0, total: 0, items: [] },
    },
    action: IWorkspaceAction
) => {
    switch (action.type) {
        // WORKSPACE STORE
        case types.GET_WORKSPACE_LIST_REQUEST: {
            return {
                ...state,
                workspaceListLoading: true,
            };
        }
        case types.GET_WORKSPACE_LIST_SUCCESS: {
            return {
                ...state,
                workspaceListLoading: false,
                workspaceList: action.payload?.data,
            };
        }
        case types.GET_WORKSPACE_LIST_FAILURE: {
            return {
                ...state,
                workspaceListLoading: false,
                workspaceListError: action.error,
            };
        }

        case types.CREATE_WORKSPACE_REQUEST: {
            return {
                ...state,
                createWorkspaceLoading: true,
            };
        }
        case types.CREATE_WORKSPACE_SUCCESS: {
            return {
                ...state,
                createWorkspaceLoading: false,
                workspaceList: {
                    items: [
                        action.payload?.data,
                        ...state.workspaceList?.items,
                    ],
                    total: state.workspaceList?.total + 1,
                    pageSize: state.workspaceList?.pageSize,
                },
            };
        }
        case types.CREATE_WORKSPACE_FAILURE: {
            return {
                ...state,
                createWorkspaceLoading: false,
                createWorkspaceError: action.error,
            };
        }

        case types.GET_WORKSPACE_REQUEST: {
            return {
                ...state,
                workspaceLoading: true,
            };
        }
        case types.GET_WORKSPACE_SUCCESS: {
            return {
                ...state,
                workspaceLoading: false,
                currentWorkspace: action.payload?.data,
            };
        }
        case types.GET_WORKSPACE_FAILURE: {
            return {
                ...state,
                workspaceLoading: false,
                currentWorkspaceError: action.error,
            };
        }
        case types.UPDATE_WORKSPACE_REQUEST: {
            return {
                ...state,
                updateWorkspaceLoading: true,
            };
        }
        case types.UPDATE_WORKSPACE_SUCCESS: {
            return {
                ...state,
                updateWorkspaceLoading: false,
                currentWorkspace: action.payload?.data,
                workspaceList: {
                    ...state.workspaceList,
                    items: state.workspaceList.items.map((item: any) =>
                        item.id === action.payload?.data.id
                            ? { ...item, ...action.payload?.data }
                            : item
                    ),
                },
            };
        }
        case types.UPDATE_WORKSPACE_FAILURE: {
            return {
                ...state,
                updateWorkspaceLoading: false,
                currentWorkspaceError: action.error,
            };
        }
        case types.CREATE_DUMMY_REQUEST: {
            return {
                ...state,
                dummyDataLoading: true,
            };
        }
        case types.CREATE_DUMMY_SUCCESS: {
            return {
                ...state,
                dummyDataLoading: false,
            };
        }
        case types.CREATE_DUMMY_FAILURE: {
            return {
                ...state,
                dummyDataLoading: false,
            };
        }
        case types.INITIATE_FILE_IMPORT_REQUEST: {
            return {
                ...state,
            };
        }
        case types.INITIATE_FILE_IMPORT_SUCCESS: {
            let loading = false;
            if (
                action.payload.type === 'status' &&
                action.payload.data.status !== 'SUCCESS'
            ) {
                loading = true;
            }

            return {
                ...state,
                initiateFileImportLoading: loading,
                initiatedFileImport: action.payload.data,
            };
        }
        case types.FILE_IMPORT_PROGRESS_REQUEST: {
            return {
                ...state,
                fileImportEventLoading: true,
            };
        }
        case types.FILE_IMPORT_PROGRESS_COMPLETE: {
            return {
                ...state,
                fileImportEventLoading: false,
            };
        }
        case types.FILE_IMPORT_PROGRESS: {
            const updateValue =
                state.fileImportList &&
                state.fileImportList.items &&
                state.fileImportList.items.some(
                    (e) => e.id === action.payload.data.id
                );
            let updateInitiated = false;
            if (action.payload.data.id === state.initiatedFileImport?.id) {
                updateInitiated = true;
            }
            return {
                ...state,
                fileImportList: {
                    ...state.fileImportList,
                    items:
                        !updateValue &&
                        state.fileImportList &&
                        state.fileImportList.items
                            ? [
                                  action.payload.data,
                                  ...state.fileImportList.items,
                              ]
                            : !updateValue
                            ? [action.payload.data]
                            : state.fileImportList.items.map((item: any) =>
                                  item.id === action.payload?.data.id
                                      ? { ...item, ...action.payload?.data }
                                      : item
                              ),
                },
                initiatedFileImport: updateInitiated
                    ? action.payload.data
                    : state.initiatedFileImport,
            };
        }
        case types.INITIATE_FILE_IMPORT_FAILURE: {
            return {
                ...state,
                initiateFileImportLoading: false,
                initiateFileImportError: action.error,
            };
        }
        case types.GET_FILE_LIST_REQUEST: {
            return {
                ...state,
                fileListLoading: action.payload.type === 'initial',
            };
        }
        case types.GET_FILE_LIST_SUCCESS: {
            return {
                ...state,
                fileListLoading: false,
                fileImportList: action.payload.data,
            };
        }
        case types.GET_FILE_LIST_FAILURE: {
            return {
                ...state,
                fileListLoading: false,
                fileImportListError: action.error,
            };
        }
        case types.SET_WORKSPACE_CONFIG_REQUEST: {
            return {
                ...state,
                [`${action.payload.configType}Loading`]: true,
            };
        }
        case types.SET_WORKSPACE_CONFIG_SUCCESS: {
            return {
                ...state,
                [`${action.payload.configType}Loading`]: false,
                [`${action.payload.configType}`]: action.payload.data,
            };
        }
        case types.SET_WORKSPACE_CONFIG_FAILURE: {
            return {
                ...state,
                [`${action.payload.configType}Loading`]: false,
                [`${action.payload.configType}Error`]: action.error,
            };
        }
        case types.SAVE_FILE_IMPORT_MAPPING_SUCCESS: {
            return {
                ...state,
                savedMapping: action.payload.data,
            };
        }
        case types.DELETE_DRAFT_IMPORT_SUCCESS: {
            return {
                ...state,
                fileImportList: {
                    ...state.fileImportList,
                    items: state.fileImportList.items.filter(
                        (item) => item.id !== action.payload.fileImportId
                    ),
                },
            };
        }
        case types.GET_WORKSPACE_USER_ROLE_REQUEST: {
            return {
                ...state,
                workspaceUserRoleLoading: true,
            };
        }
        case types.GET_WORKSPACE_USER_ROLE_SUCCESS: {
            return {
                ...state,
                workspaceUserRoleLoading: false,
                workspaceUserRole: action.payload.data,
            };
        }
        case types.GET_WORKSPACE_USER_ROLE_FAILURE: {
            return {
                ...state,
                workspaceUserRoleLoading: false,
                workspaceUserRoleError: action.error,
            };
        }
        case types.RESET_WORKSPACE: {
            return {
                ...state,
                currentWorkspace: {},
            };
        }
        case types.RESET_FILE_IMPORT_STATUS: {
            return {
                ...state,
                initiateFileImportLoading: false,
                initiatedFileImport: null,
            };
        }
        case types.RESET_FILE_LIST: {
            return {
                ...state,
                fileImportList: [],
            };
        }

        default:
            return state;
    }
};
